import { useCallback, useEffect, useState } from "react";

/**
 * Real URLs, in about twenty lines.
 *
 * The Compose front end kept the current screen in memory, so a reload always landed on Now and a
 * link to a run could not be sent to anybody. The server already answers every non-`/api` path with
 * `index.html`, so the only thing that was missing was this.
 *
 * A router library would be four times the code for a dashboard with five paths.
 */
export function useRoute(): [string, (to: string) => void] {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = useCallback((to: string) => {
    if (to === window.location.pathname) return;
    window.history.pushState(null, "", to);
    setPath(to);
  }, []);

  return [path, navigate];
}
